import {sortCaret, toAbsoluteUrl} from "../../_metronic/_helpers";
import {
  CreatedAtColumnFormatter,
  EnabledColumnFormatter,
  PremiumColumnFormatter,
  UpdatedAtColumnFormatter
} from "./column-formatters";
import React from "react";
import SVG from "react-inlinesvg";

export const api_url = process.env.REACT_APP_API_URL
export const api_format = "YYYY-MM-DD HH:mm:ss"
export const upload_path = api_url+"/uploads";
export const languages = ["ar","fr","en"]
export const preDefinedNutrition  = {
  carb: {ar:"كربوهيدرات", en:"Carb", fr:"Carb"},
  fat: {ar:"دهون", en:"Fats", fr:"Graisses"},
  protein: {ar:"بروتينات", en:"Proteins", fr:"Protéines"},
};
export const preDefineIngredients  = {
  _1: {ar:"سكر", en:"Sugar", fr:"Sucre"},
  _2: {ar:"بيض", en:"Egg", fr:"Oeuf"},
  _3: {ar:"طحين", en:"Flour", fr:"Farine "},
  _4: {ar:"حليب", en:"Milk", fr:"Lait "},
  _5: {ar:"ملح", en:"Salt", fr:"Sel"},
};

export const enabledMap = {
  true:"Disabled",
  false:"Enabled",
}


export const getFormData = (entity)=>{
  const formData = new FormData();
  if(entity._file)
  {
    formData.append('_file', entity._file);
    delete entity._file;
  }
  if(entity._file_female)
  {
    formData.append('_file_female', entity._file_female);
    delete entity._file_female;
  }
  formData.append("object", JSON.stringify(entity));
  return formData;
}

export const axiosFormDataConfigs = {
  headers : {
    'accept': 'application/json',
    'Content-Type': `multipart/form-data;`,
  }
}

export const TABLE_COLUMNS = {
  enabled: {
    dataField: "enabled",
    text: "Status",
    sort: true,
    sortCaret: sortCaret,
    formatter: EnabledColumnFormatter,
  },
  premium: {
    dataField: "premium",
    text: "Premium",
    sort: true,
    sortCaret: sortCaret,
    formatter: PremiumColumnFormatter,
  },
  created_at:{
    dataField: "created_at",
    text: "Created At",
    sort: true,
    sortCaret: sortCaret,
    formatter: CreatedAtColumnFormatter,
  },
  updated_at:{
    dataField: "updated_at",
    text: "Updated At",
    sort: true,
    sortCaret: sortCaret,
    formatter: UpdatedAtColumnFormatter,
  },
  file_name:(UPLOAD_PATH)=>{
    return {
        dataField: "file_name",
            text: "Cover",
          sort: true,
          sortCaret: sortCaret,
          formatter: (cellContent, row) => {
            let url = `${UPLOAD_PATH}/default.png`;
            let isVideo = false;
            if(row.file_name) {
              url = `${UPLOAD_PATH}/${row.id}/${row.file_name}`;
              if(row.file_mime_type.includes("video/")) isVideo = true;
            }
            return (
                <div className="symbol symbol-70 symbol-2by3 mr-3">
                  <div className="symbol-label float-right" style={{backgroundImage: "url("+url+")"}}>
                    <a href={url} target={"_blank"} className="mt-auto ml-auto">
                      {isVideo ? "Video" : ""}
                      <span className="svg-icon svg-icon-md svg-icon-primary">
                        <SVG
                          src={toAbsoluteUrl("/media/svg/icons/General/Expand-arrows.svg")}
                        />
                      </span>
                    </a>
                  </div>
                </div>
            )
          },
      }
    }
}


export const levels = ['Beginner','Intermediate','Advanced']


export const Currency = ({value})=>{
  return `${value} MAD`
}

export const ROLES = {
  ROLE_ADMIN:"Admin",
  ROLE_USER:"User"
}

export const EXERCISE_TYPES = {
  BODY:"Body",
  STRETCH:"Stretch",
  CARDIO:"Cardio",
  STRENGTH:"Strength",
}